export const checkIfAccountSetupIsNeeded = async (data = {}) => {
    
      const axios = (await import(/* webpackPrefetch: true */ "axios")).default;

      if(window.appUserInterface !== "business") return false;

      const url = `${window.apiEndPoint}/apps/${window.appUserInterface}/profileDetails/setupStatus/${window.userLanguage}`;

      const res = await axios.get(url, {params:{ } }).then(async (response) => {

            let model = response.data;

            console.log("++++++++++++++++++++++ model here is ", model);
            return model.msg == "accountSetupNeeded" ? true : false;

      }).catch((error) => {

            console.log(error);
            return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: "txt423" }] });

      }).finally(() => {

      });

      return res;
};

